import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["frame"]
  }

  static get values() {
    return { domain: String, loaded: Boolean, source: String, onLoad: Boolean }
  }

  connect() {
    if (this.onLoadValue) {
      this.load()
    }
  }

  load() {
    if (this.loadedValue) {
      return
    }

    this.frameTarget.src = `/search/${this.domainValue}/technologies.html?source=${this.sourceValue}`
    this.frameTarget.reload()

    this.loadedValue = true
  }
}
